import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, ReplaySubject } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Persona } from '../../models/persona';

@Injectable()
export class PersonaService {
  private _personas: ReplaySubject<Persona[]> = new ReplaySubject<Persona[]>();
  public personas$: Observable<Persona[]> = this._personas.asObservable();

  constructor(private _http: HttpClient) {
    this._http.get(environment.personaUrl).subscribe(data => {
      this._personas.next(
        (data as Persona[]).sort((a: Persona, b: Persona) => {
          // sort the Personas!
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        })
      );
    });
  }
}
